const base_path = "https://admin.adolfoconstructors.org/api/";

const endpoints = {
  clients: `${base_path}client/all-for-web`,
  construction: `${base_path}construction/all-for-web`,
};

export default endpoints;
